import React, { useEffect, useState } from 'react';
import BackToTop from '../../components/elements/BackToTop';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/logo-1.png';
import FooterTwo from '../../components/Layout/Footer/FooterStyleTwo';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import bannerbg from '../../assets/images/backgrounds/breadcrumb-1-1-1.webp';
import CtaTwo from '../../components/Common/CtaSection/CtaTwo';
import SkylineMain from './SkylineMain';
import { Helmet } from 'react-helmet';
import FaqMain from '../faq/FaqMain';


// Breadcrumbs Background Image

const Skyline = () => {

    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <React.Fragment>
             <Helmet>
                <title>Design & Implementation- techtotalers</title>
            </Helmet>
        <Header
            navImg={navImg1}
            parentMenu='peak-performance-roofing'
            activeMenu="/peak-performance-roofing"
        />
        {/* SiteBreadcrumb */}
        <SiteBreadcrumb
            pageTitle="Design Implementation"
            pageName="Design Implementation"
            breadcrumbsImg={bannerbg}
        />
        {/* SiteBreadcrumb */}
        <SkylineMain/>
        <FaqMain/>
        <div style={{ height: '100px' }}></div> 
        {/*cta-section */}
        <CtaTwo/>
        {/*cta-section end */}
        <BackToTop scroll={isVisible} />
        <FooterTwo />
    </React.Fragment>
    );
}

export default Skyline;